import { createSlice } from "@reduxjs/toolkit";
import { AppState } from "../store";
import { WorksStatisticServiceImpl } from "../services/WorksStatisticServiceImpl";
import { InitialWorksStatistic } from "../domain/models/WorksStatistic";
import { STATISTIC_LIMIT } from "../domain/constants";

export const worksStatisticSlice = createSlice({
    name: "worksStatistic",
    initialState: InitialWorksStatistic,
    reducers: {},
    extraReducers: (builder) => {
        // handle get /works-statistic/year
        builder.addCase(
            WorksStatisticServiceImpl.getYearStatisticThunk.fulfilled,
            (state, action) => {
                state.worksStatisticYear = action.payload;
            }
        );
    },
});

export const selectWorksStatisticYear = (state: AppState) => {
    return [...state.worksStatistic.worksStatisticYear]
        .filter((item) => !!item.min && !!item.max)
        .sort((a, b) => b.min - a.min)
        .slice(0, STATISTIC_LIMIT);
};

export default worksStatisticSlice.reducer;
